<div>
    <h6>The email address "<b>{{ checkedEmailAddress }}</b>" is already being used by:</h6>
</div>

<div class="table-responsive pt-3">
    <table class="table table-bordered">
        <thead>
            <tr>
                <th style="width: 24%;">Account No</th>
                <th style="width: 66%;">Account Name / Default Address</th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let row of matches" class="customer-result">
                <td class="align-middle">
                    <div class="text-primary h6 m-0"><b>{{ row.accountNumber }}</b></div>
                </td>
                <td class="align-middle">
                    <div>{{ row.accountName | titlecase}}</div>
                    <div>
                        <ng-container *ngIf="row.defaultAddress; else none">
                            <!-- only show the default address name if it differs from the account name -->
                            <ng-container *ngIf="row.accountName != row.defaultAddress?.details?.name">
                                {{ row.defaultAddress?.details?.name| titlecase }}<span *ngIf="row.defaultAddress?.details?.name && (row.defaultAddress?.details?.name || row.defaultAddress?.details?.addressLine1)">,</span>
                            </ng-container>
                            {{ row.defaultAddress?.details?.addressLine1| titlecase }}<span *ngIf="row.defaultAddress?.details?.addressLine1 && (row.defaultAddress?.details?.addressLine2 || row.defaultAddress?.details?.postalCode)">,</span>
                            {{ row.defaultAddress?.details?.addressLine2| titlecase }}<span *ngIf="row.defaultAddress?.details?.addressLine2 && (row.defaultAddress?.details?.postalCode)">,</span>
                            {{ row.defaultAddress?.details?.postalCode | uppercase }}<span *ngIf="row.defaultAddress?.details?.postalCode && (row.defaultAddress?.details?.countryName)">,</span>
                            {{ row.defaultAddress?.details?.countryName | titlecase }}
                        </ng-container>
                        <ng-template #none>No Default Address</ng-template>
                    </div>
                    <div>
                        <span class="text-muted">Tel: </span>{{ row.contact[0].telephoneNumber ? row.contact[0].telephoneNumber : 'none'}} , <span class="text-muted">Mob: </span>{{ row.contact[0].mobileNumber ? row.contact[0].mobileNumber : 'none' }}
                    </div>
                    <div>
                        <span class="text-muted">Email:</span> {{row.contact[0].emailAddress}}
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>